"use client";

import { ForgeIcon } from "@forge-ui-components/atoms";
import { useState } from "react";
import AuthorPicture from "./AuthorPicture.tsx";

const DEFAULT_IMAGE_PATH = "/content/dam/research/img/placeholder_person_2.png";
const CROSS_DISCIPLINE = "cross discipline";

type Props = {
    bioImage?: string;
    authorDisplayName: string;
    sourceDisplayName: string;
    subSourceDisplayName: string;
    legalEntityDisplayName: string;
    coveredIndustries: string[];
    email?: string;
    phone?: string;
    city?: string;
    biographyText?: string;
};

const AuthorBioCardClient = ({
    bioImage,
    authorDisplayName,
    sourceDisplayName,
    subSourceDisplayName,
    legalEntityDisplayName,
    coveredIndustries,
    email,
    phone,
    city,
    biographyText,
}: Props) => {
    const [isOpen, setIsOpen] = useState(false);
    const subSourceContainsCrossDiscipline = subSourceDisplayName?.toLowerCase().indexOf(CROSS_DISCIPLINE) !== -1;

    return (
        <div className="flex flex-col mb-1_5 px-[1.25rem] py-2">
            <div className="flex flex-row">
                <AuthorPicture
                    className="hidden md:block"
                    src={bioImage || DEFAULT_IMAGE_PATH}
                    defaultSrc={DEFAULT_IMAGE_PATH}
                    alt=""
                />
                <div className="flex flex-col ml-[1.25rem]">
                    {/* Mobile */}
                    <AuthorPicture
                        className="block md:hidden"
                        src={bioImage || DEFAULT_IMAGE_PATH}
                        defaultSrc={DEFAULT_IMAGE_PATH}
                        alt=""
                    />

                    <div className="text-[1.875rem] mb-1 mt-2 text-center md:text-left">{authorDisplayName}</div>
                    <div className="text-[#999999] text-[0.9375rem] font-sans text-center md:text-left">
                        <span>
                            {sourceDisplayName && (
                                <strong>
                                    {sourceDisplayName}
                                    {(subSourceDisplayName?.replaceAll(CROSS_DISCIPLINE, "") ||
                                        coveredIndustries.length > 0 ||
                                        city ||
                                        legalEntityDisplayName) &&
                                        "  |  "}
                                </strong>
                            )}{" "}
                            {subSourceDisplayName && !subSourceContainsCrossDiscipline && (
                                <>
                                    {subSourceDisplayName.replaceAll(CROSS_DISCIPLINE, "")}
                                    {(coveredIndustries.length > 0 || city || legalEntityDisplayName) && "  |  "}
                                </>
                            )}{" "}
                            {coveredIndustries.length > 0 && (
                                <>
                                    {coveredIndustries.join(", ")}
                                    {(city || legalEntityDisplayName) && "  |  "}
                                </>
                            )}
                            {legalEntityDisplayName && (
                                <>
                                    {legalEntityDisplayName}
                                    {city && "  |  "}
                                </>
                            )}
                            {city}
                        </span>
                    </div>

                    <div className="flex flex-row gap-[10px] text-[0.9375rem] font-sans mt-1 text-center justify-center md:text-left md:justify-start">
                        {email && (
                            <div>
                                <a href={`mailto:${email}`}>
                                    <span>
                                        <ForgeIcon classNames="inline" icon="mail" pxSize={20} />
                                        {email}
                                    </span>
                                </a>
                            </div>
                        )}
                        {phone && (
                            <div>
                                <a href={`tel:${phone}`}>
                                    <span>
                                        <ForgeIcon classNames="inline" icon="phone" pxSize={20} />
                                        {phone}
                                    </span>
                                </a>
                            </div>
                        )}
                        {biographyText && (
                            <div>
                                <a href="#" onClick={() => setIsOpen(!isOpen)}>
                                    <span>Biography</span>{" "}
                                    <ForgeIcon
                                        classNames="inline"
                                        icon={isOpen ? "keyArrowUp" : "keyArrowDown"}
                                        pxSize={20}
                                    />
                                </a>
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <div>{isOpen && biographyText}</div>
        </div>
    );
};

export { AuthorBioCardClient };
